import { IDocumentCardPreviewProps, ImageFit } from "@fluentui/react";
import { LearningType } from "../../Types/LearningType";

export const getCardPreviewProps = async (cardData: LearningType): Promise<IDocumentCardPreviewProps> => {
    const images = (require as any).context("../../assets", true);
    const defaultImageUrl = images("./Default-learncard-img.png");

    // Check image accessibility using Image() instead of fetch()
    const checkImage = (url: string): Promise<string> =>
        new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(url);  // If image loads, return original URL
            img.onerror = () => resolve(defaultImageUrl); // If error, return default image
        });

    // Get valid image URL
    const validImageUrl = cardData.imageUrl ? await checkImage(cardData.imageUrl) : defaultImageUrl;

    return {
        previewImages: [
            {
                previewImageSrc: validImageUrl,
                linkProps: {
                    href: cardData.learnMoreUrl,
                    target: "_blank",
                },
                imageFit: ImageFit.cover,
                height: 196,
            },
        ],
    };
};
